/* eslint-disable */
export default {
  meetingTitle: '{extensionName} 的會議',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
